"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var calcite_web_min_js_1 = require("calcite-web/dist/js/calcite-web.min.js");
var AppConfig_1 = require("../../AppConfig");
var AboutModal = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\n    .modal-content{\n        background-color: ", ";\n        color: ", ";\n    }\n\n    .btn, a {\n        color: rgb(242, 203, 131);\n    }\n"], ["\n\n    .modal-content{\n        background-color: ", ";\n        color: ", ";\n    }\n\n    .btn, a {\n        color: rgb(242, 203, 131);\n    }\n"])), AppConfig_1.UIConfig.ThemeColorDarkPurple, AppConfig_1.UIConfig.ThemeColorYellow);
var AboutThisApp = function () {
    React.useEffect(function () {
        calcite_web_min_js_1.modal();
    }, []);
    return (React.createElement(AboutModal, { className: "js-modal modal-overlay", "data-modal": "about" },
        React.createElement("div", { className: "modal-content column-12", role: "dialog", "aria-labelledby": "modal" },
            React.createElement("span", { className: "js-modal-toggle right cursor-pointer", "aria-label": "close-modal" },
                React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "21", height: "21", viewBox: "0 0 32 32", className: "svg-icon" },
                    React.createElement("path", { d: "M18.404 16l9.9 9.9-2.404 2.404-9.9-9.9-9.9 9.9L3.696 25.9l9.9-9.9-9.9-9.898L6.1 3.698l9.9 9.899 9.9-9.9 2.404 2.406-9.9 9.898z" }))),
            React.createElement("h3", { className: 'trailer-half avenir-demi' }, "About this app"),
            React.createElement("p", null, "This map presents active wildfires in the United States. Fires are sorted by burn size (in the grid view) or age (in the timeline view)."),
            React.createElement("p", null, "The fires source is the Integrated Reporting of Wildland-Fire Information (IRWIN) location database along with the polygon perimeters from the National Interagency Fire Center (NIFC). Both layers update every 15 minutes."),
            React.createElement("p", null,
                "Smoke forecasts are disseminated by the National Weather Service and show a 48-hour forecast window in 1-hour increments. More information about this service can be found ",
                React.createElement("a", { href: 'https://www.arcgis.com/home/item.html?id=a98fd08751a5480c898b7cebe38807f4', target: '_blank' }, "here"),
                "."),
            React.createElement("p", null,
                "When zoomed-in, additional fire points will appear. These are NOAA/NASA satellite-detected locations of recent \u201Cthermal activity\u201D that can provide an indication of fire direction. Learn more about this data ",
                React.createElement("a", { href: 'https://www.arcgis.com/home/item.html?id=dece90af1a0242dcbf0ca36d30276aa3', target: '_blank' }, "here"),
                "."),
            React.createElement("p", null,
                "This application is an unofficial presentation of this data and is intended for reference only. It was designed by Esri\u2019s ",
                React.createElement("a", { href: 'https://github.com/vannizhang', target: '_blank' }, "Jinnan Zhang"),
                " and ",
                React.createElement("a", { href: 'https://adventuresinmapping.com/', target: '_blank' }, "John Nelson"),
                ", using Firefly symbology available in ",
                React.createElement("a", { href: 'https://www.esri.com/arcgis-blog/products/arcgis-living-atlas/mapping/whats-new-in-arcgis-online-firefly/', target: '_blank' }, "ArcGIS Online"),
                " and ",
                React.createElement("a", { href: 'https://www.esri.com/arcgis-blog/products/arcgis-pro/mapping/steal-this-firefly-style-please/', target: '_blank' }, "ArcGIS Pro"),
                ", and the ",
                React.createElement("a", { href: 'https://livingatlas.arcgis.com/en/browse/#d=1&q=%22World%20Imagery%20(Firefly)%22', target: '_blank' }, "Firefly basemap"),
                "."),
            React.createElement("div", { className: "text-right" },
                React.createElement("button", { className: "btn btn-transparent js-modal-toggle" }, "Close")))));
};
exports.default = AboutThisApp;
var templateObject_1;
